import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Banknote } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { FinanceDashboard } from "@/features/finance/components/finance-dashboard";
// AUTONOMY · Layer 3: ayuda contextual de caja.

function FinancePage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`Cashier`)}
          description={t(
            msg`Record tuition payments in USD or VES, keep the daily rate, and print receipts. Recorded payments wait for admin verification.`,
          )}
          icon={Banknote}
        />
      </div>
      <div class="mt-4">
        <FinanceDashboard />
      </div>
    </PageContainer>
  );
}

export const financeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance",
  component: withFeatureGate("billing.core", FinancePage),
});
